/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-title-spacing',
  templateUrl: './theme-option-tooltips-title-spacing.component.html',
  styleUrls: ['./theme-option-tooltips-title-spacing.component.css']
})
export class ThemeOptionTooltipsTitleSpacingComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_titleSpacing';

  constructor() {}

  receiveValue(value: string) {
    this.themeOptions.setOption('tooltips_titleSpacing', value);
  }

}
